var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightDoubleArrow = function SvgRightDoubleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 15"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6-5h24v24H-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2276E3",
    fillRule: "nonzero",
    d: "m6.345 14.399-.114-.003a.864.864 0 0 1-.637-1.354l3.95-5.678a.29.29 0 0 0 0-.329l-3.95-5.68A.864.864 0 0 1 7.013.37l3.949 5.678c.479.692.479 1.61 0 2.302l-3.95 5.678a.86.86 0 0 1-.781.367zm-5.77-.288a.576.576 0 0 1-.472-.902l3.95-5.678a.58.58 0 0 0 0-.66L.103 1.193A.576.576 0 0 1 .576.288h1.928c.188 0 .365.092.472.247l3.95 5.678c.411.594.411 1.38 0 1.973l-3.95 5.678a.58.58 0 0 1-.472.247z"
  }))));
};
export default SvgRightDoubleArrow;